var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.clickCurrent == _vm.index,
            expression: "clickCurrent==index"
          }
        ],
        class: _vm.isShow ? "view-log-min-footer" : "view-log-realtime-footer"
      },
      [
        _c("div", [
          _c(
            "div",
            {
              staticStyle: {
                color: "#6f7886",
                lineHeight: "18Px",
                width: "100%",
                height: "50Px",
                marginBottom: "15Px"
              }
            },
            [
              _vm.isShow
                ? _c("span", [
                    _c("div", { staticClass: "log-line" }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(_vm.$t("language.common.sync")) + ":")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "catelog-color catelog-style ",
                          class: [
                            _vm.$i18n.locale == "italian"
                              ? "catelog-width-it"
                              : "catelog-width"
                          ],
                          attrs: {
                            title: _vm._f("getCatalogTitle")(
                              _vm._f("getCatalog")(_vm.allItem.fromItem.nodes)
                            )
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toSourceCatalog(_vm.allItem.fromItem)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("getCatalog")(_vm.allItem.fromItem.nodes)
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "log-line" }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(_vm.$t("language.common.with")) + ":")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "catelog-color catelog-style",
                          class: [
                            _vm.$i18n.locale == "italian"
                              ? "catelog-width-it"
                              : "catelog-width"
                          ],
                          attrs: {
                            title: _vm._f("getCatalogTitle")(
                              _vm._f("getCatalog")(_vm.allItem.toItem.nodes)
                            )
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toAimCatalog(_vm.allItem.toItem)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("getCatalog")(_vm.allItem.toItem.nodes)
                            )
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "log-line" }, [
                _c("div", { staticClass: "log-realTimeline-left" }, [
                  _vm._v(
                    "\r\n                                " +
                      _vm._s(_vm.$t("language.common.result")) +
                      ":"
                  ),
                  _vm.temp && _vm.temp.response == "success"
                    ? _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("language.common.success")))
                      ])
                    : _vm._e(),
                  _vm.temp && _vm.temp.response == "error"
                    ? _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("language.common.failure")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.temp && _vm.temp.response == "cancel"
                    ? _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("language.common.cancel")))
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "log-line" }, [
                _vm.temp
                  ? _c("div", { staticClass: "log-realTimeline-all" }, [
                      _vm._v(
                        "\r\n                                " +
                          _vm._s(_vm.$t("language.common.fileProcess")) +
                          ":"
                      ),
                      _c(
                        "span",
                        {
                          attrs: {
                            title:
                              "Add[" +
                              _vm.temp.addFile +
                              "] Update[" +
                              _vm.temp.updateFile +
                              "] Delete[" +
                              _vm.temp.deleteFile +
                              "]"
                          }
                        },
                        [
                          _vm._v(
                            " Add[" +
                              _vm._s(_vm.temp.addFile) +
                              "] Update[" +
                              _vm._s(_vm.temp.updateFile) +
                              "] Delete[" +
                              _vm._s(_vm.temp.deleteFile) +
                              "]"
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "log-line" }, [
                _vm.temp
                  ? _c("div", { staticClass: "log-realTimeline-left" }, [
                      _vm._v(
                        "\r\n                                 " +
                          _vm._s(_vm.$t("language.common.dataProcess")) +
                          ":"
                      ),
                      _c(
                        "span",
                        { attrs: { title: _vm.getDataProcessTitle(_vm.temp) } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatByte")(
                                  _vm.temp.fileTotalReadedBytes
                                )
                              ) +
                              "/" +
                              _vm._s(_vm._f("formatByte")(_vm.temp.totalBytes))
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "log-line" }, [
                _c("div", { staticClass: "log-realTimeline-left" }, [
                  _vm._v(
                    "\r\n                               " +
                      _vm._s(_vm.$t("language.cloudSync.createdAt")) +
                      ":"
                  ),
                  _c(
                    "span",
                    {
                      attrs: {
                        title: _vm._f("transferForMatTime")(
                          _vm.allItem.createTime
                        )
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("transferForMatTime")(_vm.allItem.createTime)
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.temp
                  ? _c("div", { staticClass: "log-line-right" }, [
                      _vm._v(
                        "\r\n                                " +
                          _vm._s(_vm.$t("language.cloudSync.lastSync")) +
                          ":"
                      ),
                      _c("span", { attrs: { title: _vm.temp.lastSyncTime } }, [
                        _vm._v(_vm._s(_vm.temp.lastSyncTime))
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "log-line" }, [
                _vm.temp
                  ? _c("div", { staticClass: "log-realTimeline-left" }, [
                      _vm._v(
                        "\r\n                               " +
                          _vm._s(_vm.$t("language.common.averageRateSpecial")) +
                          ":"
                      ),
                      _c(
                        "span",
                        { attrs: { title: _vm.getAvgSpeed(_vm.temp) } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatByteSpeed")(
                                  _vm.temp.fileTotalReadedBytes /
                                    (_vm.temp.taskElaspedTimeLong / 1000)
                                )
                              )
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.temp
                  ? _c("div", { staticClass: "log-line-right" }, [
                      _vm._v(
                        "\r\n                                 " +
                          _vm._s(_vm.$t("language.common.executedTimes")) +
                          ":"
                      ),
                      _c("span", { attrs: { title: _vm.temp.runCount } }, [
                        _vm._v(_vm._s(_vm.temp.runCount))
                      ])
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _vm.temp && _vm.temp.errorList.length
            ? _c("div", { staticClass: "log-line" }, [
                _c(
                  "div",
                  {
                    staticClass: "log-realTimeline-left click-log-red",
                    on: {
                      click: function($event) {
                        return _vm.openFailedFiles()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("language.common.viewFailed")))]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.temp && _vm.temp.response == "success"
            ? _c("div", { staticClass: "log-line" }, [
                _vm._v(
                  "\r\n                               " +
                    _vm._s(_vm.$t("language.common.fileSuccess")) +
                    "\r\n                         "
                )
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f36cc9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f36cc9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tab_realTime_logs.vue
// module id = null
// module chunks = 